<template>
    <div>
         <el-form  label-width="100px" :rules="rules" ref="memberInfo" :model="memberInfo" >
          <el-row>
              <el-col :lg="10" >
                  <el-form-item label="姓名:" prop="name">
                      <el-input v-model="memberInfo.name"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="性別">
                      <el-radio-group v-model="memberInfo.sex" >
                          <el-radio :label="2">男</el-radio>
                          <el-radio :label="1">女</el-radio>
                      </el-radio-group>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" >
                 <el-form-item label="生日:" prop="birthday">
                      <el-date-picker v-model="memberInfo.birthday" type="date" placeholder="選擇日期"></el-date-picker>
                 </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="手機:" prop="phone">
                      <el-input v-model="memberInfo.phone"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" >
                  <el-form-item label="膚質:">
                      <el-input v-model="memberInfo.skin"  style="width:50%;"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="婚姻狀況:">
                      <el-select v-model="memberInfo.married" placeholder="">
                          <el-option v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                      </el-select>
                      
                  </el-form-item>
                  
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="22" >
                        <el-form-item label="地址:" >
                               <el-select v-model="memberInfo.city" placeholder="" @change="queryArea" >
                               <el-option v-for="item in getCityItems"
                                   :key="item.city"
                                   :label="item.city"
                                   :value="item.city">
                               </el-option>
                           </el-select>
                           <el-select v-model="memberInfo.area" placeholder="" >
                               <el-option v-for="item in getAreaItems"
                                   :key="item.area"
                                   :label="item.area"
                                   :value="item.area">
                               </el-option>
                           </el-select>
                           
                               <el-input v-model="memberInfo.address" style="width:50%;"></el-input>
                           
                    </el-form-item>
              </el-col>
              
          </el-row>
          <el-row>
              <el-col :lg="12" >
                  <el-form-item label="Email:">
                      <el-input v-model="memberInfo.email"></el-input>
                  </el-form-item>
              </el-col>
             
          </el-row>
          <el-row>
              <el-col :lg="10" >
            <el-form-item label="店櫃:" prop="shop_key" >
                             <el-select v-model="memberInfo.shop_key" @change="checkBrand">
                             <el-option v-for="item in getShopList"
                                 :key="item._key"
                                 :label="item.name"
                                 :value="item._key"
                                 clearable
                                 >
                             </el-option>
                         </el-select>
            </el-form-item>
               
             </el-col>
              <el-col :lg="10" >
                  <el-form-item label="品牌:">
                      <el-input v-model="brand_id" style="width:50%;" readonly  ></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" >
                  <el-form-item label="美容師:">
                      <el-select v-model="memberInfo.user_key" :disabled="memberInfo.shop_key == '' ? true: false">
                          <el-option v-for="item in user"
                              :key="item._key"
                              :label="item.name"
                              :value="item._key">
                          </el-option>
                      </el-select>
                      
                  </el-form-item>
              </el-col>
              <el-col :lg="10" ></el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" :offset="2" >
                  <el-button type="primary" @click="updateMember('memberInfo')"> <i class="el-icon-edit" ></i>修改</el-button>
                  <el-button type="default" @click="back">返回</el-button>
              </el-col>
              <el-col :lg="10" ></el-col>
          </el-row>
          
      </el-form>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import { async } from 'q'
    export default {
        name: 'Edit',
        props: {
            memberKey: String
        },
        data() {
            return {
                memberInfo: {},
                rules: {
                    name:[
                        {required: true, message: '請輸入名字'}
                    ],
                    birthday: [
                        {required: true, message: '請輸入生日'}
                    ],
                    shop_key: [
                        {required: true, message: '請輸入店櫃'}
                    ],
                    phone: [
                        {required: true, message: '請輸入手機號碼'}
                    ]
                },
                options: [{
                    value: 1,
                    label: '未婚'
                },{
                      value: 2,
                      label: '已婚'  
                },{
                    value: 3,
                    label: '其他'
                }
                ],
                shops: [],
                shop: [],
                user: [],
                brand_id: '',
            }
        },
        computed: mapGetters(["getAreaItems", "getCityItems", "beauticiansItems", "getShopDetail", "getShopList", "getMemberError", "getMemberMsg", "getMemberDetail"]) ,
        methods: {
            ...mapActions(["fetchArea", "fetchCity", "fetchShop", "fetchMemberDetail", "fetchShopDetail", "updateMember"]),
            fetchMember: async function () {
              const data = await {_key: this.memberKey};
              await this.$store.dispatch('fetchMemberDetail', data)
              this.memberInfo = this.getMemberDetail
              this.checkBrand(this.memberInfo.shop_key)
            },
                    queryArea: function(){
          let city = this.memberInfo.city
          let cityName = {city}
          this.$store.dispatch('fetchArea', cityName )
         },
          queryShop: async function(){
             const data =  {}
             await this.$store.dispatch('fetchShop', data)
          
                 this.shops = await this.getShopList
           
                
            
         },
            checkBrand: async function (key) {
           const data = await {_key: key}; 
           await this.$store.dispatch('fetchShopDetail', data) 
                   if( this.memberInfo.brand_id== 1){
                   this.brand_id = await 'N牌'
            }else {
                   this.brand_id = await 'S牌'
            }
                this.user = await this.beauticiansItems
         },
         updateMember:  function (formName) {
             console.log(this.memberInfo)
             this.$refs[formName].validate((valid) => {
                 if (valid) {
                      const strDate =  moment(this.memberInfo.birthday).format('YYYY-MM-DD')  
                     const data = {
                         _key: this.memberInfo._key,
                               brand_id: this.memberInfo.brand_id,
                name: this.memberInfo.name,
                phone: this.memberInfo.phone,
                married: this.memberInfo.married,
                skin: this.memberInfo.skin,
                sex: this.memberInfo.sex,
                email: this.memberInfo.email,
                city: this.memberInfo.city,
                area: this.memberInfo.area,
                address: this.memberInfo.address,
                user_key: this.memberInfo.user_key,
                shop_key: this.memberInfo.shop_key,
                referrer_card_number: this.memberInfo.referrer_card_number,
                birthday: strDate
                     }
                     this.$store.dispatch('updateMember', data)
                     if (this.getMemberError != true) {
                         this.$emit('back')
                         this.$refs[formName].resetFields();
                     }else {
                           this.$message({
                    message: this.getMemberMsg,
                    type: 'error'
                })
                     }
                 }else {
                       this.$message({
                    message: '無法通過驗證',
                    type: 'error'
                })
                 }
             })
         },
         back: function () {
             this.$emit('back')
         }
         
        },
        created() {
            this.fetchMember()
            this.fetchCity()
           
        },
    }
</script>

<style lang="scss" scoped>
    el-form {
        margin: 0 auto;
        padding: 0;
        
        color: aqua;
           font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
         a{
             font-size: 28px;
             font-weight: bold;
         }
    }
</style>